<template>
  <footer>
    <!-- <div class="links-1 border-1">
      <select name="anetWork" v-model="selectedNetWork" class="w-236" @change="selectChange">
        <option value="#" selected>===省、市、自治区残联网站===</option>
        <option v-for="n in oneList" :key="n.netUrl" :label="n.netName" :value="n.netUrl" />
      </select>
      <select name="bnetWork" v-model="selectedNetWork" class="w-236" @change="selectChange">
        <option value="#" selected>===省内地级市残联网站===</option>
        <option v-for="n in twoList" :key="n.netUrl" :label="n.netName" :value="n.netUrl" />
      </select>
      <select name="cnetWork" v-model="selectedNetWork" class="w-236" @change="selectChange">
        <option value="#" selected>===中国残联直属单位网站===</option>
        <option v-for="n in threeList" :key="n.netUrl" :label="n.netName" :value="n.netUrl" />
      </select>
      <select name="dnetWork" v-model="selectedNetWork" class="w-236" @change="selectChange">
        <option value="#" selected>===国内残疾人相关网站===</option>
        <option v-for="n in fourList" :key="n.netUrl" :label="n.netName" :value="n.netUrl" />
      </select>
    </div> -->
    <!-- <div class="links-2">
      <ul>
        <li>
          <a target="_blank" href="http://www.cdpf.org.cn/" title="中国残疾人联合会">
            <img src="../../static/img/foot-view/link-1.jpg" alt="中国残疾人联合会" />
          </a>
        </li>
        <li>
          <a target="_blank" href="http://service.cdpf.org.cn/" title="中国残疾人服务平台">
            <img src="../../static/img/foot-view/link-2.jpg" alt="中国残疾人服务平台" />
          </a>
        </li>
        <li>
          <a target="_blank" href="http://www.cdpee.org.cn/" title="中国残联就创业服务平台">
            <img src="../../static/img/foot-view/link-3.jpg" alt="中国残联就创业服务平台" />
          </a>
        </li>
        <li>
          <a target="_blank" href="http://www.my33er.com/" title="中国听障儿童服务网">
            <img src="../../static/img/foot-view/link-4.jpg" alt="中国听障儿童服务网" />
          </a>
        </li>
        <li>
          <a target="_blank" href="http://www.blc.org.cn/" title="中国盲人数字图书馆">
            <img src="../../static/img/foot-view/link-5.jpg" alt="中国盲人数字图书馆" />
          </a>
        </li>
      </ul>
    </div> -->
    <div class="foot-1"></div>
    <div class="foot-2">
      版权所有：石家庄市残疾人联合会 <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">冀ICP备12013774号-1</a>
      <span v-if="baseUrl != undefined"><a :href="baseUrl + '/page?classId=032018931669'">联系我们</a></span>
      <a href="#">返回旧网站</a>
      <table>
        <tbody>
          <tr>
            <td style="width:50%; text-align:right;">
              <a
                href="//bszs.conac.cn/sitename?method=show&id=09700262919F35FEE053022819AC9705"
                target="_blank"
              >
                <img src="//dcs.conac.cn/image/red.png" />
              </a>
            </td>
            <td style="width:50%; text-align:left;">
              <p class="p-style">
                <span class="span-one">
                  <a href="http://www.cyberpolice.cn" target="_blank">
                    <!-- <img src="http://124.239.213.197:8081/xinbeian/Public/images/cyberPolice/cyberPoliceGif_02.gif" width="40px" height="39px" border="0"> -->
                  </a>
                </span>
                <span class="span-two">
                  <a href="http://www.cyberpolice.cn" target="_blank">公安机关备案号13010502001198</a>
                </span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </footer>
</template>

<script>
import disabled from "../http/getdata";
import { mapState } from "vuex";
//此处导入的名称 应与 引入的export的名称相同
// default export 的函数不用{}    如果不加括号必须要用
export default {
  arr: [],
  name: "Footer",
  data() {
    return {
      network: "",
      selectedNetWork: "#",
      selectList: []
    };
  },
  props:["baseUrl"],
  methods: {
    selectChange() {
      if (this.selectedNetWork != "" && this.selectedNetWork != "#") {
        window.open(this.selectedNetWork, "_blank");
        this.selectedNetWork = "#";
      }
    }
  },

  created(arr) {
    disabled.disabled(arr).then(data => {
      this.selectList = data;
    });
  },

  computed: {
    oneList: function() {
      return this.selectList.filter(function(selectList) {
        return selectList.netType == 1; //返回netType=1的项，添加到oneList数组
      });
    },
    twoList: function() {
      return this.selectList.filter(function(selectList) {
        return selectList.netType == 2; //返回netType=1的项，添加到oneList数组
      });
    },
    threeList: function() {
      return this.selectList.filter(function(selectList) {
        return selectList.netType == 3; //返回netType=1的项，添加到oneList数组
      });
    },
    fourList: function() {
      return this.selectList.filter(function(selectList) {
        return selectList.netType == 4; //返回netType=1的项，添加到oneList数组
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.foot-2 {
  table {
    width: 100%;
    border: 0px;
  }
}
.p-style {
  border: 1px solid #e0e0e0;
  height: 50px;
  line-height: 20px;
  margin: 6px;
  padding: 0;
  width: 158px;
  font-size: 12px;
  color: #999;
}
.span-one {
  float: left;
  padding: 2px 0 0 5px;
}
.span-two {
  float: right;
  padding: 5px 3px 0;
  width: 100px;
  a {
    font-size: 12px;
    color: #999;
    text-decoration: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue